var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413391 15.1305C1.1077 17.7067 2.63794 19.9395 4.69566 21.5206V15.1305H0.413391Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 23.9544C11.3005 23.984 11.6483 24 12 24C17.5443 24 22.2096 20.2396 23.5866 15.1305H10.9565V23.9544Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 8.86955C22.2096 3.76036 17.5443 0 12 0C11.6483 0 11.3005 0.0160312 10.9565 0.0456562V8.86955H23.5866Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69566 2.47946C2.63794 4.06056 1.1077 6.29335 0.413391 8.86955H4.69566V2.47946Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H9.39136H9.39131V0.285248C8.28234 0.531154 7.23098 0.929732 6.26086 1.45909V10.4348H0.101578C0.0347813 10.9472 0 11.4695 0 12C0 12.5305 0.0347813 13.0529 0.101578 13.5652H6.26081H6.26086V22.5409C7.23098 23.0702 8.28234 23.4689 9.39131 23.7147V13.5654V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9472 23.8984 10.4348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceland);
export default __webpack_public_path__ + "static/media/iceland.f680ec4482d5014f6cc9a83b4d9c69eb.svg";
export { ForwardRef as ReactComponent };